export default {
    task: {
        getMyCash: 'ਮੇਰਾ ਨਕਦ ਲਿਆਓ',
        chances: 'ਵਾਰੀਆਂ ਬਾਕੀ',
        tips: 'ਕਾਰਡ ਪਾਉਣ ਲਈ ਟਿਪਸ',
        daily: 'ਰੋਜ਼ਾਨਾ ਚੈੱਕ-ਇਨ',
        watch: 'ਕੋਈ ਵੀ ਵੀਡੀਓ ਵੇਖੋ',
        share: 'ਮੁਕਾਬਲੇ ਨੂੰ ਸਾਂਝਾ ਕਰੋ',
        free: 'ਮੁਫ਼ਤ ਨਕਦ ਅਤੇ ਕਾਰਡ  + 1',
        done: 'ਪੂਰਾ ਹੋਇਆ',
        go: 'ਜਾਓ',
        success: 'ਸਫਲਤਾਪੂਰਵਕ',
        checkIn: 'ਚੈੱਕ ਇਨ ਕੀਤਾ',
        successCheckIn: 'ਸਫਲਤਾਪੂਰਵਕ ਚੈੱਕ ਇਨ ਕੀਤਾ!',
        successWatched: 'ਸਫਲਤਾਪੂਰਵਕ ਵੇਖਿਆ!',
        successShared: 'ਸਫਲਤਾਪੂਰਵਕ ਸਾਂਝਾ ਕੀਤਾ!',
        won: 'ਤੁਸੀ ਜਿੱਤੇ',
        card: 'ਕਾਰਡ',
        msg: 'ਤੁਹਾਡੇ ਖਾਤੇ ਚ ਪੈਸੇ ਜਮਾ ਹੋ ਗਇ ਹਨ',
        ok: 'ਠੀਕ ਹੈ',

        nochance: 'ਤੁਸੀਂ ਸਭ ਖਤਮ ਨਹੀਂ ਕੀਤਾ',
        cards: '4-ਕਾਰਡ ',
        collection:'ਸੰਗ੍ਰਹਿ',
        watchVideo:'ਵੀਡੀਓ ਵੇਖੋ ',
        toGet:'ਹੋਰ ਕਾਰਡ ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ'
    },
    
    rules: {
        ruleTitle: "ਨਿਯਮ",
        validityDate: "ਉਚਿੱਤ ਤਾਰੀਖ : 8 ਮਾਰਚ, 2020 -15 ਮਾਰਚ, 2020",
        prizeRedeem: "ਇਨਾਮ ਰਿਡੀਮ ਕਰੋ: ਬਕਾਇਆ 15 ਆਰ ਤੱਕ ਪੁੱਜਣ ਤੋਂ ਬਾਅਦ ਉਪਭੋਗਤਾ ਆਪਣੀ ਨਕਦੀ ਵਾਪਸ ਲੈ ਸਕਦੇ ਹਨ, ਕਾਰਵਾਈ 7 ਕੰਮਕਾਜੀ ਦਿਨਾਂ ਵਿਚ ਪੂਰੀ ਹੋ ਜਾਵੇਗੀ",
        gameRule:{
            title:"ਖੇਡ ਦੇ ਨਿਯਮ:",
            ruleList: [
                "1. ਉਪਭੋਗਤਾ ਦੈਨਿਕ ਚੈੱਕ - ਇਨ ਕਰਨ ਉੱਤੇ ਨਕਦ ਅਤੇ 1 ਕਾਰਡ ਪ੍ਰਾਪਤ ਕਰ ਸਕਦੇ ਹਨ ",
                "2. ਉਪਭੋਗਤਾ ਪ੍ਰਤੀ ਦਿਨ ਕਿਸੇ ਵੀ ਵੀਡੀਓ ਨੂੰ ਪੂਰਾ ਕਰਨ ਉੱਤੇ ਨਕਦ ਅਤੇ 1 ਕਾਰਡ ਪ੍ਰਾਪਤ ਕਰ ਸਕਦੇ ਹਨ",
                "3. ਵਟਸਐਪ ਗਰੁੱਪ ਜਾਂ ਫੇਸ ਬੁੱਕ ਜਾਂ ਇੰਸਟਾਗਰਾਮ ਆਦਿਕ ਦੀ ਗਤੀਵਿਧੀ ਨੂੰ ਸਾਂਝਾ ਕਰਨ ਉੱਤੇ ਉਪਭੋਗਤਾ ਨਕਦ ਅਤੇ 1 ਕਾਰਡ ਪ੍ਰਾਪਤ ਕਰ ਸਕਦੇ ਹਨ",
                "4. ਇੱਕ ਵਾਰ ਸਾਰੇ 4 ਕਾਰਡ ਇਕੱਠੇ ਕਰਨ ਤੋਂ ਬਾਅਦ, ਉਪਭੋਗਤਾ ਨੂੰ ਲਾਟਰੀ ਕੱਢਣ ਦਾ ਮੌਕਾ ਮਿਲ ਸਕਦਾ ਹੈ ।  3 ਮਿਲੀਅਨ ਰੁਪਏ ਦੇ ਨਕਦ ਭੰਡਾਰ ਵਿਚੋ ਹਰ ਲੱਕੀ ਡਰਾਅ 100 % -ਨਿਸ਼ਚਿਤ-ਜੇਤੂ ਲੱਕੀ ਡਰਾਅ ਹੈ, ਹਰ ਇੱਕ ਉਪਭੋਗਤਾ ਅਧਿਕਤਰ 20000 ਰੁਪਏ ਡਰਾਅ ਕਰ ਸਕਦਾ ਹੈ"
            ]
        },
        msg:"SHAREit ਅੰਤਿਮ ਸਪਸ਼ਟੀਕਰਨ ਲਈ ਸਾਰੇ ਅਧਿਕਾਰ ਸੁਰੱਖਿਅਤ ਰੱਖਦਾ ਹੈ"
    },
    share: {
        title:"*ਮਜ਼ਾਕ ਨਹੀਂ ਕਰ ਰਹੇ, ਦੋਸਤੋ, ਇਹ ਹੋਲੀ, SHAREit 30 ਲੱਖ ਰੁਪਏ ਦੀ ਨਕਦ ਰਾਸ਼ੀ ਦਾ ਵਿਤਰਨ ਕਰੇਗੀ!*😊\n*ਮੇਰੇ ਨਾਲ ਸ਼ਾਮਲ ਹੋਵੋ ਅਤੇ 20000 ਰੁ ਹਾਸਿਲ ਕਰਨ ਲਈ ਵੀਡੀਓ ਵੇਖੋ, ਹਰ ਕੋਈ 100% ਜਿੱਤੇਗਾ*💰\n*ਮੇਰੇ ਕੋਲ ਪਹਿਲਾਂ ਹੀ ਮੁਫ਼ਤ ਨਕਦ ਪ੍ਰਾਪਤ ਹੋਇਆ ਹੈ, ਇਹ 100% ਸੱਚ ਹੈ.*\n*ਚਲੋ ਹੁਣ SHAREit  ਹੋਲੀ ਮੁਕਾਬਲੇ ਵਿਚ ਸ਼ਾਮਲ ਹੋਵੋ!*💕👇🏻👇🏻👇🏻"
    }
}